const ADMIN_CONSOLE_ROUTE_CONTENTS = {
  ADMIN_CONSOLE: "Admin console",
  REPORTING: "Reporting",
  STUDENTS: "Students",
  SCHOOLS: "Schools",
  CLASS_ROOMS: "Classes",
  TEACHERS: "Faculty",
  CONTENT_ADVISORY: "Content advisory",
  CONTENT_RESTRICTION: "Content restriction",
  ADMIN_QUICK_START: "Admin quick start",
  CONTENT_PROMOTION: "Content promotion",
};

export default ADMIN_CONSOLE_ROUTE_CONTENTS;
